export class StringHelper {
  public static isRegex(str: string): boolean {
    return !!str && str.charAt(0) === '/' && str.charAt(str.length - 1) === '/';
  }
}
